/* eslint-disable */
import { filter, update } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import countries from 'countries-list';
import axios from 'axios';
import NoteIcon from '@mui/icons-material/Note';
import ClearIcon from '@mui/icons-material/Clear'; // Import the close icon
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ErrosAlert from './ErrosAlert';
import { vatFormats, validateVatNumber, vatPlaceholder } from 'src/utils/formatNumber';
// material
import { TextField, Snackbar, TableBody, TableCell, Container } from '@mui/material';
import { Autocomplete, Typography, TableContainer, TablePagination, IconButton } from '@mui/material';
import { Button, Card, Alert, Table, Stack, Box, Modal, Tooltip, TableHead, TableRow, CircularProgress } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import SelectReact from 'react-select';
// components
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import HistoryIcon from '@mui/icons-material/History';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Page from '../../../components/Page';
import Scrollbar from '../../../components/Scrollbar';
import Iconify from '../../../components/Iconify';
import SearchNotFound from '../../../components/SearchNotFound';
import { ListHead, ListToolbar } from '../../../sections/@dashboard/table';
import Loader from '../../../components/Loader';
import { customerDropOptions, formatDate, getModalBoxStyle } from '../../../utils/commonFunc';
import TooltipWithCopy from '../../../components/TooltipWithCopy';
import SSNVerificationModal from '../../../components/SSNVerificationModal';
// import RenderCustomers from './RenderCustomers';

// ----------------------------------------------------------------------

function VatStatusBadge({ isVatVerified }) {
  if (isVatVerified === true) {
    return (
      <span style={{ color: '#2e7d32', fontWeight: 600, background: '#e8f5e9', borderRadius: 12, padding: '2px 10px', fontSize: 13, whiteSpace: 'nowrap' }}>
        🟢 Verified
      </span>
    );
  }
  if (isVatVerified === false) {
    return (
      <span style={{ color: '#c62828', fontWeight: 600, background: '#ffebee', borderRadius: 12, padding: '2px 10px', fontSize: 13, whiteSpace: 'nowrap' }}>
        🔴 Unverified
      </span>
    );
  }
  return (
    <span style={{ color: '#757575', fontWeight: 600, background: '#f5f5f5', borderRadius: 12, padding: '2px 10px', fontSize: 13, whiteSpace: 'nowrap' }}>
      ⚪ Not Checked
    </span>
  );
}

const TABLE_HEAD = [
  { id: 'customerId', label: 'Id', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'ssn', label: 'SSN', alignRight: false },
  { id: 'accountType', label: 'Business Type', alignRight: false },
  { id: 'vatStatus', label: 'VAT Status', alignRight: false },
  { id: '', label: 'Actions' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const escapeRegExp = (value) => value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    const searchRegex = new RegExp(escapeRegExp(query), 'i');
    return filter(array, (_row) =>
      Object.keys(_row).some((field) => {
        if (_row[field]) return searchRegex.test(_row[field].toString());
        return false;
      })
    );
  }
  return stabilizedThis?.map((el) => el[0]);
}

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [searchQuery, setSearchQuery] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [loading, setLoading] = useState(false);
  const [showCustomerDetails, setShowCustomerDetails] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const [autoHideDuration, setAutoHideDuration] = useState(3000);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertStatus, setAlertStatus] = useState('success');
  const [totalCount, setTotalCount] = useState(0);
  const [isAllSelected, setAllSelected] = useState(false);
  const [toggleNote, setToggleNote] = useState(false);
  const [notesContent, setNotesContent] = useState('');
  const [isNotesContentEmpty, setIsNotesContentEmpty] = useState(false);
  const [commentList, setcommentList] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [countryVal, setCountryValue] = useState(false);
  const [editLanguage, setEditLanguage] = useState('sv-se');
  const [userAccountType, setUserAccountType] = useState('');
  const [invoiceType, setInvoiceType] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [searchDropValue, setSearchDropValue] = useState();
  const [selectedTabValue, setSelectedTabValue] = useState('1');
  const [isVatRegisterSelected, setIsVatRegisterSelected] = useState(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [showSyncModal, setshowSyncModal] = useState(false);
  const [isError, setisError] = useState(false);
  const [viewSurveyAnswers, setViewSurveyAnswers] = useState(false);
  const [surveyAnswers, setSurveyAnswers] = useState([]);
  const [surveyAnswersLoading, setSurveyAnswersLoading] = useState(false);
  const [paramsCalled, setParamsCalled] = useState(true);
  const [useExistingPostal, setUseExistingPostal] = useState(true);
  
  const [messages, setMessages] = useState({
    customerUpdatedOnFortnox: null,
    customerUpdatedOnFortnoxError: null,
    customeraddedOnFortnox: null,
    customeraddedOnFortnoxError: null,
    invoiceCanceledOnFortnox: null,
    invoiceCanceledOnFortnoxError: null,
    invoiceFileuploadedOnFortnox: null,
    invoiceFileuploadedOnFortnoxError: null,
    invoiceTaxReductioncreatedOnFortnox: null,
    invoiceTaxReductioncreatedOnFortnoxError: null,
    invoiceUpdatedOnFortnox: null,
    invoiceUpdatedOnFortnoxError: null,
    invoiceaddedOnFortnox: null,
    invoiceaddedOnFortnoxError: null,
  });
  const [noteType, setNoteType] = useState('General'); // Dropdown value
  const [surveyNotes, setSurveyNotes] = useState([]);  // Survey notes/questions
  const [surveyLoading, setSurveyLoading] = useState(false);
  const [surveyRatings, setSurveyRatings] = useState({}); // { [SurveyQuestionId]: rating }
  const [surveySubmitted, setSurveySubmitted] = useState(false); // <-- Add this state
  const [customQuestion, setCustomQuestion] = useState('');
  const [customRating, setCustomRating] = useState(0);
  const [surveyReloaded, setSurveyReloaded] = useState(false); // New state to track survey reloading
   const [secondaryChecked, setSecondaryChecked] = useState(false);
  const [isVatVerifiedChecked, setIsVatVerifiedChecked] = useState(false);
  const [ssnVerificationModal, setSsnVerificationModal] = useState({
    show: false,
    expectedData: null,
    sparData: null,
    reason: '',
    status: '',
    customerId: null,
    ssn: null,
    isSsnValid: null,
    isPending: false
  });
  // const [vatCountryCode, setVatCountryCode] = useState("SE"); 
  const [countryName, setCountryName] = useState("");
  const [vatActionCustomer, setVatActionCustomer] = useState(null); // customer object being acted on
  const [vatConfirmAction, setVatConfirmAction] = useState(null); // null | 'verify' | 'unverify'
  const [vatVerifyLoading, setVatVerifyLoading] = useState(false);
  useEffect(() => {
    setCountryCode(countryCode || "SE");
  }, [countryCode]);

  const { customerId } = useParams();
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    if (customerId) {
      setSearchQuery(customerId);
      setSearchDropValue(1);
      setPage(0);
    }
  }, [customerId]);

  const {
    register,
    reset,
    watch,
    handleSubmit,
    resetField,
    setValue,
    formState: { errors },
  } = useForm();
  
 useEffect(() => {
      const postalAddr = showCustomerDetails?.postAddress || '';
      const postalCity = showCustomerDetails?.postCity || '';
      const postalCountry = showCustomerDetails?.postCountry || '';
      const postalZip = showCustomerDetails?.postZipCode || '';
      const postalCountryCode = showCustomerDetails?.postCountryCode || '';
      setValue('postAddress', postalAddr);
      setValue('postCity', postalCity);
      setValue('postCountry', postalCountry);
      setValue('postZipCode', postalZip);
      setValue('postCountryCode', postalCountryCode);
      
      const hasPostalData = Boolean(postalAddr || postalCity || postalCountry || postalZip || postalCountryCode);
      setUseExistingPostal(!hasPostalData);
      try {
        register && register('useExistingPostal');
      } catch (e) {
      }
      setValue('useExistingPostal', hasPostalData);
      
      const isSecondaryEmail = showCustomerDetails?.isSecondaryEmailAddress === 'true' || showCustomerDetails?.isSecondaryEmailAddress === true;
      setSecondaryChecked(!isSecondaryEmail);
    
  }, [showCustomerDetails, setValue]);

  useEffect(() => {
    // Update vatCountryCode when countryName changes
    let code = "";
    Object.keys(countries.countries).forEach((c) => {
      if (countries.countries[c].name === countryName) {
        code = c;
      }
      if (countryName === "USA") {
        code = "US";
      }
    });
    // if (code) setVatCountryCode(code);
    if (code) setCountryCode(code);

  }, [countryName]);

  const selectedCountry = watch('country');
  useEffect(() => {
    const currentCountry = selectedCountry || countryName;
    const currentAccountType = userAccountType;
    if (currentCountry === 'Sweden' && currentAccountType === 'Business Construction') {
      setIsVatRegisterSelected(true);
      setValue('isVATRegistred', 'true');
    }

  }, [countryName, selectedCountry, userAccountType, setValue]);

  const countryCodeOptions = Object.keys(countries.countries).map((code) => ({
    value: code,
    label: code,
  }));

  const isVATRegistred = watch('isVATRegistred');
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleDownloadSurvey = async () => {
    try {
      const response = await axios.get('/AdminNotesSurvey/export-survey?surveyType=6', {
        responseType: 'blob',
      });

      let fileName = 'survey-notes.csv';
      const disposition = response.headers['content-disposition'];
      if (disposition && disposition.indexOf('filename=') !== -1) {
        fileName = disposition.split('filename=')[1].replace(/"/g, '').trim();
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error('Failed to download survey notes.');
    }
  };

  const handleUploadToComplyCube = async (userId) => {
    try {
      setLoading(true);
      const response = await axios.post(`admin/user/send-customer-details-complycube?userId=${userId}`);
      if (response?.data?.statusCode === 200) {
        setAlertMessage('User uploaded to ComplyCube successfully');
        setAlertStatus('success');
        setIsSnackBarOpen(true);
        await fetchCustomers();
      }
      else {
        setAlertMessage(response?.data?.message || 'Failed to upload to ComplyCube');
        setAlertStatus('error');
        setIsSnackBarOpen(true);
      }
    } catch (err) {
      setAlertMessage(err?.response?.data?.message || 'Failed to upload to ComplyCube');
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleManualSSNVerification = async (customerId, ssn) => {
    try {
      setLoading(true);
      const response = await axios.get(`admin/ssn-verified-manually/${customerId}`);
      if (response.data.statusCode === 200) {
        setAlertMessage('Customer marked as verified successfully');
        setAlertStatus('success');
        await fetchCustomers();
        setSsnVerificationModal({ show: false, expectedData: null, sparData: null, reason: '', status: '', customerId: null, ssn: null, isSsnValid: null, isPending: false });
      } else {
        setAlertMessage(response?.data?.message || 'Failed to mark as verified');
        setAlertStatus('error');
        setIsSnackBarOpen(true);
      }
    } catch (err) {
      setAlertMessage(err?.response?.data?.message || 'Failed to mark as verified');
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSSNVerification = async (customerId, ssn) => {
    setLoading(true);
    try {
      const response = await axios.get(`/admin/ssn-verification/${customerId}/${ssn}`);
      if (response?.data?.statusCode === 200 && response?.data?.response === true && (response?.data?.status === 'failed' || response?.data?.status === 'success')) {
        const verificationData = response.data;
        const expectedData = verificationData.details?.expected || {
          firstName: name?.split(' ')[0] || '',
          lastName: name?.split(' ').slice(1).join(' ') || '',
          dateOfBirth: '',
        };
        const sparData = verificationData.details?.spar || {};

        setSsnVerificationModal({
          show: true,
          expectedData: expectedData,
          sparData: sparData,
          reason: verificationData.reason || verificationData.message || 'Verification completed',
          status: verificationData.status,
          customerId: customerId,
          ssn: ssn,
          isSsnValid: response?.data?.statusCode === 200,
          isPending: false,
        });
        setLoading(false);
        fetchCustomers();
        setAlertMessage('SSN verified successfully');
        setAlertStatus('success');
        setIsSnackBarOpen(true);
        setLoading(false);
        setTimeout(() => {
          fetchCustomers();
        }, 500);
      } else {
        setAlertMessage(response?.data?.message || 'Failed to verify SSN');
        setAlertStatus('error');
        setIsSnackBarOpen(true);
        setLoading(false);
        fetchCustomers();
      }
    } catch (err) {
      console.log('SSN Verification Error:', err?.response?.data);

      if (err?.response?.data?.status && (err?.response?.data?.status === 'failed' || err?.response?.data?.status === 'success')) {
        const verificationData = err.response.data;
        const expectedData = verificationData.details?.expected || {
          firstName: name?.split(' ')[0] || '',
          lastName: name?.split(' ').slice(1).join(' ') || '',
          dateOfBirth: '',
        };
        const sparData = verificationData.details?.spar || {};

        setSsnVerificationModal({
          show: true,
          expectedData: expectedData,
          sparData: sparData,
          reason: verificationData.reason || verificationData.message || 'Verification failed',
          status: verificationData.status,
          customerId: customerId,
          ssn: ssn,
          isSsnValid: false,
          isPending: false,
        });
        setLoading(false);
        fetchCustomers();
      } else {
        const errorMessage = err?.response?.data?.message || err?.message || 'Failed to verify SSN';
        setAlertMessage(errorMessage);
        setAlertStatus('error');
        setIsSnackBarOpen(true);
        setLoading(false);
        fetchCustomers();
      }
    }
  };
  
  const fetchCustomers = useCallback(async () => {
    try {
      setLoading(true);
      const customerIdFromParams = customerId;
      let URL;
      if (searchDropValue && searchQuery) {
        URL = `/admin/user/all-customers?PageSize=${rowsPerPage}&PageNumber=${page + 1
          }&searchQuery=${searchQuery}&SearchColumn=${searchDropValue}`;
      }
      else if (customerIdFromParams) {
        if (paramsCalled) {
          URL = `/admin/user/all-customers?PageSize=${rowsPerPage}&PageNumber=${page + 1
            }&searchQuery=${customerIdFromParams}&SearchColumn=${1}`;
          setParamsCalled(false);
        }
        else {
          URL = `/admin/user/all-customers?PageSize=${rowsPerPage}&PageNumber=${page + 1}&searchQuery=${searchQuery}`;
        }
      }
      else {
        URL = `/admin/user/all-customers?PageSize=${rowsPerPage}&PageNumber=${page + 1}&searchQuery=${searchQuery}`;
      }

      const res = await axios.get(URL);
      if (res?.status === 200) {
        setLoading(false);
        const customerId = new URLSearchParams(search).get('notificationVal');

        const editCustomers = res?.data?.response?.map((ele) => ({ ...ele, isEdit: false }));

        const filteredRows = applySortFilter(editCustomers, getComparator(order, orderBy), searchQuery);

        const notificationFilteredList = filteredRows?.map((item) => ({
          ...item,
          isSelected: item.customerId === Number(customerId),
        }));
        setCustomers(notificationFilteredList);
        selectAllClick(isAllSelected, notificationFilteredList);

        setTotalCount(res.data.totalCount);

        setFilteredCustomers(notificationFilteredList);
      }
    } catch (err) {
      if (err?.response?.data?.message === 'Something went wrong please try again after sometime.') {
        fetchCustomers();
        setLoading(true);
      } else {
        setCustomers([]);
        setLoading(false);
      }
      console.log(err);
    }
  }, [page, rowsPerPage, searchQuery, searchDropValue, search, customerId]);

  useEffect(() => {
    if (showCustomerDetails) {
      const vatStatus = showCustomerDetails.isVATRegistred === 'true' || showCustomerDetails.isVATRegistred === true;
      setIsVatRegisterSelected(vatStatus);
      setValue('isVATRegistred', vatStatus ? 'true' : 'false');
      setIsInitialLoad(false);
    }
  }, [showCustomerDetails, setValue]);

  useEffect(() => {
    console.log('Fetching customers with params:', { page, rowsPerPage, searchQuery, searchDropValue });
    fetchCustomers();
  }, [fetchCustomers, page, rowsPerPage, searchQuery]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const selectAllClick = (isSelected, filteredCustomers) => {
    if (isSelected) {
      const newSelecteds = filteredCustomers?.map((n) => n.customerId);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleSelectAllClick = (event) => {
    setAllSelected(event.target.checked);
    selectAllClick(event.target.checked, filteredCustomers);
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilter = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleRowClick = (event, id) => {
    navigate(`/dashboard/invoices/${id}?column=7`);
  };

  const filteredRows = applySortFilter(customers, getComparator(order, orderBy), searchQuery);
  const isVatReg = (r) => r.isVATRegistred === true || r.isVATRegistred === 'true';
  const isNotFound = filteredRows.length === 0;
  const getUserDetails = (id) => {
    const customer = customers.find((customers) => customers.customerId === id);
    setShowCustomerDetails(customer);

    const isSecondaryEmail = customer?.isSecondaryEmailAddress === 'true' || customer?.isSecondaryEmailAddress === true;
      setSecondaryChecked(!isSecondaryEmail);
    setIsVatVerifiedChecked(customer?.isVatVerified === true);
    setShowEditModal(true);
    setEditLanguage(customer?.language || 'sv-se');

    const characters = customer?.vatNumber?.match(/[a-zA-Z]+/g);
    const characterResult = characters ? characters.join('').slice(0, 2) : '';
    setCountryCode(characterResult);

    const numberResult = customer?.vatNumber?.slice(2);
    setUserAccountType(
      (customer.accountType === 1 && 'Private Customer') ||
      (customer.accountType === 2 && 'Business Customer') ||
      (customer.accountType === 3 && 'Business Construction')
    );

    setInvoiceType(
      (customer.customerAddress[0].invoiceType === 1 && 'Email (send to email address)') ||
      (customer.customerAddress[0].invoiceType === 2 && 'E-invoice (send as electronic invoice)') ||
      (customer.customerAddress[0].invoiceType === 3 && 'Post (60 SEK)')
    );
    reset({
      name: customer?.name,
      email: customer?.email,
      orgNo: customer?.orgNo,
      ssn: customer?.ssn,
      country: customer?.country,
      phoneNumber: customer?.phoneNumber,
      isVATRegistred: customer?.isVATRegistred,
      countryCode: customer?.countryCode,
      zipCode: customer?.zipCode,
      address: customer?.address,
      address2: customer?.address2,
      language: customer?.language || 'sv-se',
      city: customer?.city,
      customerId: customer?.customerId,
      reference: customer?.reference,
      vatNumber: numberResult,
      co: customer?.co,
      paymentTerm: customer.paymentTerm,
      invoiceType:
        (customer?.customerAddress[0]?.invoiceType === 1 && 'Email (send to email address)') ||
        (customer?.customerAddress[0]?.invoiceType === 2 && 'E-invoice (send as electronic invoice)') ||
        (customer?.customerAddress[0]?.invoiceType === 3 && 'Post (60 SEK)'),
      accountType:
        (customer.accountType === 1 && 'Private Customer') ||
        (customer.accountType === 2 && 'Business Customer') ||
        (customer.accountType === 3 && 'Business Construction'),
      yourElectronicReference: customer?.customerAddress[0].yourElectronicReference,
      extraField1: customer?.customerAddress[0]?.extraField1,
      extraField2: customer?.customerAddress[0]?.extraField2,
      globalLocationNumber: customer?.customerAddress ? customer?.customerAddress?.[0]?.globalLocationNumber : "",
      postAddress: customer?.postAddress || '',
      postCity: customer?.postCity || '',
      postCountry: customer?.postCountry || '',
      postZipCode: customer?.postZipCode || '',
      postCountryCode: customer?.postCountryCode || ''
    });
  };

  const editUserDetails = async (values) => {
    values.language = editLanguage;
    let cCode = '';
    if (
      values?.accountType !== 'Private Customer' &&
      values?.accountType != '1' &&
      (values?.isVATRegistred === 'true' || values?.isVATRegistred === true) &&
      !values?.vatNumber
    ) {
      return toast.error('Please enter your VAT number');
    }

    Object.keys(countries.countries).forEach((code) => {
      if (countries.countries[code].name === values.country) {
        setCountryCode(code);
        cCode = code;
      }
    });

    try {
      setLoading(true);

      let concatVatNumber;
      if (values?.accountType == '1' || values?.accountType == 'Private Customer') {
        values.vatNumber = '';
      } else if (values?.isVATRegistred === 'false' || values?.isVATRegistred === false) {
        values.vatNumber = '';
      } else if (values?.isVATRegistred === 'true' || values?.isVATRegistred === true) {
        concatVatNumber = values.countryCode + values?.vatNumber;
        values.vatNumber = concatVatNumber;
      }

      if (values?.isSecondaryEmailAddress === false || values?.isSecondaryEmailAddress === 'false') {
        delete values.secondaryEmailAddress;
      }

      await axios.put('/admin/user', {
        ...values,
        invoiceType:
          (values.invoiceType === 'Email (send to email address)' && 1) ||
          (values.invoiceType === 'E-invoice (send as electronic invoice)' && 2) ||
          (values.invoiceType === 'Post (60 SEK)' && 3),
        accountType:
          (values.accountType === 'Private Customer' && 1) ||
          (values.accountType === 'Business Customer' && 2) ||
          (values.accountType === 'Business Construction' && 3),
        id: showCustomerDetails.customerId,
        countryCode: values.countryCode,
        IsVatVerified: isVatVerifiedChecked
      });
      setShowEditModal(false);
      setAlertMessage('Details has been updated successfully.');
      setAlertStatus('success');
      setAutoHideDuration(3000);
      setIsSnackBarOpen(true);
      await fetchCustomers();
    } catch (err) {
      console.log(err);
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setAutoHideDuration(3000);
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };


  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const newDetails = [];
  Object.keys(countries.countries).forEach((code) => {
    newDetails.push(countries.countries[code]);
  });

  // Add Notes

  const {
    reset: resetForm3,
    register: registerForm3,
    handleSubmit: handleSubmitForm3,
    formState: { errors: errorsForm3 },
  } = useForm();

  const commentStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    width: '60%',
    height: '80%',
    marginBottom: '40',
    p: 3,
  };

  const addnoteToggle = (id) => {
    setToggleNote(true);
    resetForm3({ description: '' });
    setSelectedCustomer(id);
    setNoteType('General');
    setSurveyNotes([]);
    setSurveyRatings({});
  };

  const postAddnotes = async () => {
    try {
      if (notesContent === '' || notesContent.trim() === '') {
        setIsNotesContentEmpty(true);
        setNotesContent('');
      } else {
        setIsNotesContentEmpty(false);
        setLoading(true);
        const response = await axios.post('admin/user/customer-notes', {
          userId: 0,
          invoiceNumber: 0,
          customerId: selectedCustomer,
          description: notesContent,
          notesType: noteType === "General" ? 2 : noteType === "Economic" ? 8 : null,
        });

        if (response?.status === 200) {
          setLoading(false);
          fetchCommentList();
          setNotesContent('');
          toast.success('Notes added successfully');
          fetchCustomers();
        } else {
          setLoading(false);
          toast.error('Server Error! Please try again');
        }
      }
    } catch (err) {
      setLoading(false);
      if (err?.response?.data) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(err?.message);
      }
      setAlertStatus('error');
    } finally {
      setLoading(false);
    }
  };

  const fetchCommentList = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`admin/user/get-customer-notes?customerId=${selectedCustomer}`);
      setcommentList(res?.data?.response);
    } catch (err) {
      setcommentList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (toggleNote) {
      fetchCommentList();
    }
  }, [toggleNote, selectedCustomer]);

  const handleSnackBarClose = () => {
    setIsSnackBarOpen(false);
  };

  const customersList = ['Private', 'Business Customer', 'Business Construction'];

  const handleTabChange = (e, newValue) => {
    setSearchQuery('');
    setPage(0);
    setSelected([]);
    setSelectedTabValue(newValue);
    setAllSelected(false);
  };

  const handleSyncProceed = async () => {
    try {
      setLoading(true);
      const Url = '/admin/invoice/sync-all-data-to-fortnox';
      const result = await axios.post(Url);
      if (result?.data?.message === 'error') {
        const errors = {
          customerUpdatedOnFortnoxError: result?.data?.response?.customerUpdatedOnFortnoxError,
          customeraddedOnFortnoxError: result?.data?.response?.customeraddedOnFortnoxError,
          invoiceCanceledOnFortnoxError: result?.data?.response?.invoiceCanceledOnFortnoxError,
          invoiceFileuploadedOnFortnoxError: result?.data?.response?.invoiceFileuploadedOnFortnoxError,
          invoiceTaxReductioncreatedOnFortnoxError: result?.data?.response?.invoiceTaxReductioncreatedOnFortnoxError,
          invoiceUpdatedOnFortnoxError: result?.data?.response?.invoiceUpdatedOnFortnoxError,
          invoiceaddedOnFortnoxError: result?.data?.response?.invoiceaddedOnFortnoxError,
          // Without Error Data
          customerUpdatedOnFortnox: result?.data?.response?.customerUpdatedOnFortnox,
          customeraddedOnFortnox: result?.data?.response?.customeraddedOnFortnox,
          invoiceCanceledOnFortnox: result?.data?.response?.invoiceCanceledOnFortnox,
          invoiceFileuploadedOnFortnox: result?.data?.response?.invoiceFileuploadedOnFortnox,
          invoiceTaxReductioncreatedOnFortnox: result?.data?.response?.invoiceTaxReductioncreatedOnFortnox,
          invoiceUpdatedOnFortnox: result?.data?.response?.invoiceUpdatedOnFortnox,
          invoiceaddedOnFortnox: result?.data?.response?.invoiceaddedOnFortnox,
        };
        setMessages(errors);
        setisError(true);
        setshowSyncModal(false);
        const isUnauthorizedError = Object.values(errors).some(
          (error) => error && error.includes('Request failed: unauthorized')
        );
        if (isUnauthorizedError) {
          toast.error('Fortnox token is invalid');
        }
      }
      if (result?.data?.message === 'Success') {
        setMessages({
          customerUpdatedOnFortnox: result?.data?.response?.customerUpdatedOnFortnox,
          customeraddedOnFortnox: result?.data?.response?.customeraddedOnFortnox,
          invoiceCanceledOnFortnox: result?.data?.response?.invoiceCanceledOnFortnox,
          invoiceFileuploadedOnFortnox: result?.data?.response?.invoiceFileuploadedOnFortnox,
          invoiceTaxReductioncreatedOnFortnox: result?.data?.response?.invoiceTaxReductioncreatedOnFortnox,
          invoiceUpdatedOnFortnox: result?.data?.response?.invoiceUpdatedOnFortnox,
          invoiceaddedOnFortnox: result?.data?.response?.invoiceaddedOnFortnox,
        });
        setisError(true);
        toast.success('The Entire data of customer and invoice is sync to fortnox');
      }
      fetchCustomers();
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoading(false);
      setshowSyncModal(false);
    }
  };

  const handleButtonClick = async (customerId) => {
    setLoading(true);
    try {
      const result = await axios.post(`/admin/user/sent-incorrect-info-mail?id=${customerId}&type=1`);
      if (result?.data?.message === 'Success') {
        toast.success(result?.data?.response);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleVatVerify = async (isVerified) => {
    if (!vatActionCustomer) return;
    try {
      setVatVerifyLoading(true);
      const response = await axios.put(
        `/admin/user/customer/${vatActionCustomer.customerId}/vat-verified?isVerified=${isVerified}`
      );
      if (response?.data?.statusCode === 200) {
        toast.success(response.data.message || 'VAT verification status updated successfully');
        setVatConfirmAction(null);
        setVatActionCustomer(null);
        // Also keep edit modal in sync
        if (showCustomerDetails?.customerId === vatActionCustomer.customerId) {
          setShowCustomerDetails((prev) => ({ ...prev, isVatVerified: isVerified }));
        }
        await fetchCustomers();
      } else {
        toast.error(response?.data?.message || 'Failed to update VAT verification status');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to update VAT verification status');
    } finally {
      setVatVerifyLoading(false);
    }
  };

   const customStyles = {
    control: (styles, { isFocused }) => {
      if (errors?.country) {
        styles.borderColor = '#dc3545';
      } else if (isFocused) {
        styles.borderColor = 'none';
        styles.boxShadow = '0 0 0 0 gray';
      }

      styles['&:hover'] = {
        borderColor: 'none',
      };

      styles.fontSize = '13px';

      return styles;
    },
  };

     useEffect(()=>{
      Object.keys(countries.countries).forEach((code) => {
          if (countries.countries[code].name === countryName) {
            setCountryCode(code);
          }
          if (countryName === 'USA') {
            setCountryCode('US');
          }
        });
  },[countries])
    
 const isSecondaryEmailAddress = watch('isSecondaryEmailAddress');
  const countryOptions = [
    { value: 'Sweden', label: 'Sweden' },
    { value: 'USA', label: 'USA' },
    { value: 'Canada', label: 'Canada' },
    { value: 'Panama', label: 'Panama' },
    ...newDetails.map((country) => ({
      value: country.name,
      label: country.name,
    })),
  ];
  const RenderCustomers = () => {
    return (
      <>
        <ListToolbar
          hideEmailButton={'true'}
          numSelected={selected.length}
          searchQuery={searchQuery}
          onFilter={handleFilter}
          dropOptions={customerDropOptions}
          searchDropValue={searchDropValue}
          setSearchDropValue={setSearchDropValue}
        />
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <ListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={customers.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
                hideCheckboxColumnHeader={'true'}
              />
              <TableBody>
                {filteredRows?.map((row) => {
                  const { customerId, name, email, ssn, accountType, isNotes, isCustomerUploadedToComplyCube } = row;
                  const isItemSelected = selected.indexOf(customerId) !== -1;

                  return (
                    <TableRow
                      hover
                      key={customerId}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                      onClick={(event) => handleRowClick(event, customerId)}
                      style={{
                        backgroundColor: row?.isSelected
                          ? 'lightgrey'
                          : !row?.isAddedOnFortnox || !row?.isDetailsUpdatedOnFortnox
                            ? 'rgb(248 232 232)'
                            : '',
                        cursor: 'pointer',
                      }}
                    >
                      <TableCell align="left">{customerId}</TableCell>
                      <TableCell align="left">{name}</TableCell>
                      <TableCell align="left">{email}</TableCell>
                      <TableCell
                        align="left"
                        className="userColumn"
                        style={{ cursor: ssn && row.isSsnValid !== null ? 'pointer' : 'default' }}
                        onClick={async (event) => {
                          if (row.isSsnValid === null) {
                            event.stopPropagation();
                            return;
                          }

                          if (ssn && row.isSsnValid !== null) {
                            event.stopPropagation();

                            if (row.sparSsnInformation) {
                              try {
                                const parsedData = JSON.parse(row.sparSsnInformation);
                                if (parsedData.status === 'failed' || parsedData.status === 'success') {
                                  // Check if we have actual SPAR data structure
                                  const hasExpectedData = parsedData.details?.expected;
                                  const hasSparData = parsedData.details?.spar;

                                  // If no expected/spar data (manual verification), use row data
                                  const expectedData = hasExpectedData ? parsedData.details.expected : {
                                    firstName: name?.split(' ')[0] || '',
                                    lastName: name?.split(' ').slice(1).join(' ') || '',
                                    dateOfBirth: row.dateOfBirth || '',
                                    address: row.address || '',
                                    city: row.city || '',
                                    zipCode: row.zipCode || '',
                                  };

                                  const sparData = hasSparData ? parsedData.details.spar : {
                                    firstName: name?.split(' ')[0] || '',
                                    lastName: name?.split(' ').slice(1).join(' ') || '',
                                    dateOfBirth: row.dateOfBirth || '',
                                    address: row.address || '',
                                    city: row.city || '',
                                    zipCode: row.zipCode || '',
                                  };

                                  setSsnVerificationModal({
                                    show: true,
                                    expectedData: expectedData,
                                    sparData: sparData,
                                    reason: parsedData.reason || 'Verification successful',
                                    status: parsedData.status,
                                    customerId: customerId,
                                    ssn: ssn,
                                    isSsnValid: row.isSsnValid,
                                    isPending: false,
                                  });
                                  return;
                                }
                              } catch (err) {
                                console.error('Failed to parse sparSsnInformation', err);
                              }
                            }

                            if (!row.isSsnValid) {
                              setLoading(true);
                              try {
                                const response = await axios.get(`/admin/ssn-verification/${customerId}/${ssn}`);
                                console.log('SSN Verification Response:', response?.data);

                                // Check if response contains verification details
                                if (response?.data?.statusCode === 200 && response?.data?.response === true) {
                                  if (response?.data?.status && (response?.data?.status === 'failed' || response?.data?.status === 'success')) {
                                    const verificationData = response.data;
                                    const expectedData = verificationData.details?.expected || {
                                      firstName: name?.split(' ')[0] || '',
                                      lastName: name?.split(' ').slice(1).join(' ') || '',
                                      dateOfBirth: '',
                                    };
                                    const sparData = verificationData.details?.spar || {};

                                    setSsnVerificationModal({
                                      show: true,
                                      expectedData: expectedData,
                                      sparData: sparData,
                                      reason: verificationData.reason || verificationData.message || 'Verification completed',
                                      status: verificationData.status,
                                      customerId: customerId,
                                      ssn: ssn,
                                      isSsnValid: response?.data?.statusCode === 200,
                                      isPending: false,
                                    });
                                    setLoading(false);
                                    fetchCustomers();
                                    setAlertMessage(response?.data?.message || 'SSN verified successfully');
                                    setAlertStatus('success');
                                    setIsSnackBarOpen(true);
                                    setLoading(false);
                                    fetchCustomers();
                                  }
                                } else {
                                  const errorMessage = response?.data?.message || 'Failed to verify SSN';
                                  setAlertMessage(errorMessage);
                                  setAlertStatus('error');
                                  setIsSnackBarOpen(true);
                                  setLoading(false);
                                  fetchCustomers();
                                }
                              } catch (err) {
                                console.log('SSN Verification Error:', err?.response?.data);
                                const errorMessage = err?.response?.data?.message || err?.message || 'Failed to verify SSN';

                                // Check if error response contains verification details
                                if (err?.response?.data?.status && (err?.response?.data?.status === 'failed' || err?.response?.data?.status === 'success')) {
                                  const verificationData = err.response.data;
                                  const expectedData = verificationData.details?.expected || {
                                    firstName: name?.split(' ')[0] || '',
                                    lastName: name?.split(' ').slice(1).join(' ') || '',
                                    dateOfBirth: '',
                                  };
                                  const sparData = verificationData.details?.spar || {};

                                  setSsnVerificationModal({
                                    show: true,
                                    expectedData: expectedData,
                                    sparData: sparData,
                                    reason: verificationData.reason || verificationData.message || 'Verification failed',
                                    status: verificationData.status,
                                    customerId: customerId,
                                    ssn: ssn,
                                    isSsnValid: false,
                                    isPending: false,
                                  });
                                  setLoading(false);
                                  fetchCustomers();
                                } else {
                                  setAlertMessage(errorMessage);
                                  setAlertStatus('error');
                                  setIsSnackBarOpen(true);
                                  setLoading(false);
                                  fetchCustomers();
                                }
                              }
                            }
                          }
                        }}
                      >
                        {ssn ? (
                          row.isSsnValid === true ? (
                            <Tooltip title="Click to view verification details">
                              <span style={{ color: 'green', fontWeight: '500', textDecoration: 'underline', cursor: 'pointer' }}>
                                {ssn} ✓
                              </span>
                            </Tooltip>
                          ) : row.isSsnValid === false ? (
                            <Tooltip title="Click to verify SSN">
                              <span style={{ color: 'orange', textDecoration: 'underline' }}>
                                {ssn}
                              </span>
                            </Tooltip>
                          ) : (
                            <Tooltip title="Click to verify SSN">
                              <span
                                style={{ color: 'gray', textDecoration: 'underline', cursor: 'pointer' }}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  setSsnVerificationModal({
                                    show: true,
                                    expectedData: {
                                      firstName: name,
                                      dateOfBirth: '',
                                    },
                                    sparData: null,
                                    reason: '',
                                    status: '',
                                    customerId: row.customerId,
                                    ssn: row.ssn,
                                    isSsnValid: null,
                                    isPending: true,
                                  });
                                }}
                              >
                                {ssn}
                              </span>
                            </Tooltip>
                          )
                        ) : ""}
                      </TableCell>
                      <TableCell align="left">{customersList[accountType - 1]}</TableCell>
                      <TableCell align="left" onClick={(e) => e.stopPropagation()}>
                        {isVatReg(row) ? (
                          <Tooltip title={row.isVatVerified === true ? 'Click to remove verification' : 'Click to mark as verified'}>
                            <span
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setVatActionCustomer(row);
                                setVatConfirmAction(row.isVatVerified === true ? 'unverify' : 'verify');
                              }}
                            >
                              <VatStatusBadge isVatVerified={row.isVatVerified} />
                            </span>
                          </Tooltip>
                        ) : null}
                      </TableCell>
                      <TableCell align="right">
                        <div className="d-flex">
                          <Button
                            type="submit"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Notes"
                            variant={isNotes ? '' : 'contained'}
                            onClick={() => {
                              addnoteToggle(customerId);
                            }}
                            style={{
                              width: 50,
                              minWidth: '50px',
                              fontSize: '12px',
                              padding: '6px',
                              marginLeft: '0px',
                              marginRight: '10px',
                            }}
                          >
                            <NoteIcon style={{ color: isNotes && 'rgb(226,204,97)' }}>NoteIcon</NoteIcon>
                          </Button>

                          <IconButton
                            onClick={(event) => {
                              getUserDetails(customerId);
                              event.stopPropagation();
                            }}
                            style={{ color: 'rgb(255, 255, 255)', background: '#62b5e5' }}
                          >
                            <Iconify icon="material-symbols:edit" width={24} height={24} />
                          </IconButton>
                          <Tooltip title="View logs">
                            <Button
                              type="submit"
                              onClick={() =>
                                navigate(
                                  `/dashboard/view-logs?type=customer&id=${customerId}&fromCustomer=true`,
                                  {
                                    state: {
                                      fromCustomer: true,
                                      user: row,
                                    },
                                  }
                                )
                              }
                              style={{
                                width: 50,
                                minWidth: '50px',
                                fontSize: '12px',
                                padding: '6px',
                                marginLeft: '8px',
                              }}
                            >
                              <HistoryIcon />
                            </Button>
                          </Tooltip>
                          {(!isCustomerUploadedToComplyCube) && (
                            <Tooltip title="Upload to ComplyCube">
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handleUploadToComplyCube(customerId)}
                                style={{
                                  minWidth: '110px',
                                  fontSize: '12px',
                                  padding: '6px 12px',
                                  marginLeft: '8px',
                                }}
                              >
                                ComplyCube
                              </Button>
                            </Tooltip>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>

              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={searchQuery} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        {/* Add Notes  Modal */}
        <Modal
          open={toggleNote}
          onClose={() => {
            setToggleNote(false);
            setNotesContent('');
            setIsNotesContentEmpty(false);
            setNoteType('General');
            setSurveyNotes([]);
            setSurveyRatings({});
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={commentStyle} style={{ overflowY: 'auto' }}>
            <Box sx={{ height: 'fit-content' }} id="usersList-modal">
              <IconButton
                color="inherit"
                onClick={() => {
                  setToggleNote(false);
                  setNotesContent('');
                  setIsNotesContentEmpty(false);
                  setNoteType('General');
                  setSurveyNotes([]);
                  setSurveyRatings({});
                }}
                sx={{
                  position: 'absolute',
                  right: 5,
                  top: 0,
                }}
                aria-label="close"
              >
                <ClearIcon style={{ fontSize: 26 }} />
              </IconButton>
              <Typography id="modal-modal-title" variant="h6" component="h2" style={{ width: '100%' }}>
                Notes
              </Typography>
              {viewSurveyAnswers ? (
                <>
                  <Button
                    variant="outlined"
                    size="small"
                    style={{ margin: '10px 0 15px 0' }}
                    onClick={() => {
                      setViewSurveyAnswers(false);
                      setSurveyAnswers([]);
                    }}
                  >
                    Back
                  </Button>
                  <div style={{ marginTop: 10 }}>
                    {surveyAnswersLoading ? (
                      <div style={{ fontSize: 14, color: '#888' }}>Loading...</div>
                    ) : surveyAnswers.length === 0 ? (
                      <div style={{ fontSize: 14, color: '#888', textAlign: 'center', marginBottom: 8 }}>
                        No survey answers found.
                      </div>
                    ) : (
                      <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: isMobile ? 8 : 16 }}>
                        {surveyAnswers.map((ans, idx) => (
                          <div
                            key={idx}
                            className="survey-card"
                            style={{
                              flex: isMobile ? '1 1 100%' : '1 1 38%',
                              minWidth: isMobile ? '90vw' : 240,
                              maxWidth: isMobile ? '98vw' : 320,
                              marginBottom: isMobile ? 8 : 16,
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-start',
                              padding: isMobile ? 10 : 14,
                              borderRadius: 10,
                              background: 'linear-gradient(135deg, #f9f9f9 60%, #e3f2fd 100%)',
                              boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
                              minHeight: 80,
                              border: '1px solid #e0e0e0',
                              position: 'relative',
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              style={{
                                marginBottom: 6,
                                fontWeight: 600,
                                color: '#1976d2',
                                fontSize: isMobile ? 13 : 15,
                                lineHeight: 1.3,
                              }}
                            >
                              {ans.surveyQuestion || ans.customQuestion || 'Question'}
                            </Typography>
                            {ans.answer && !ans.customQuestion ? (
                              <div style={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
                                {[1, 2, 3, 4, 5].map((star) => (
                                  <span
                                    key={star}
                                    style={{
                                      color: star <= Number(ans.answer) ? '#FFD700' : '#e0e0e0',
                                      fontSize: isMobile ? 20 : 22,
                                      marginRight: 2,
                                      filter: 'drop-shadow(0 1px 2px #eee)',
                                      userSelect: 'none',
                                    }}
                                  >
                                    ★
                                  </span>
                                ))}
                                <span style={{ marginLeft: 8, color: '#888', fontSize: isMobile ? 12 : 13 }}>
                                  ({ans.answer} / 5)
                                </span>
                              </div>
                            ) : ans.customQuestion ? (
                              <div style={{ marginTop: 2, color: '#333', fontSize: isMobile ? 14 : 15, display: 'flex', alignItems: 'center' }}>
                                <span style={{ marginLeft: 6, display: 'flex', alignItems: 'center' }}>
                                  {[1, 2, 3, 4, 5].map((star) => (
                                    <span
                                      key={star}
                                      style={{
                                        color: star <= Number(ans.customAnswer) ? '#FFD700' : '#e0e0e0',
                                        fontSize: isMobile ? 20 : 22,
                                        marginRight: 2,
                                        filter: 'drop-shadow(0 1px 2px #eee)',
                                        userSelect: 'none',
                                      }}
                                    >
                                      ★
                                    </span>
                                  ))}
                                  <span style={{ marginLeft: 8, color: '#888', fontSize: isMobile ? 12 : 13 }}>
                                    ({ans.customAnswer || '-'} / 5)
                                  </span>
                                </span>
                              </div>
                            ) : (
                              <div style={{ marginTop: 2, color: '#888', fontSize: isMobile ? 13 : 14 }}>
                                No answer
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{
                      minWidth: 180,
                      marginTop: "20px",
                      background: "#fff",
                      borderRadius: 8,
                      border: "1px solid #e0e0e0",
                      boxShadow: "none",
                      padding: 2,
                    }}
                  >
                    <InputLabel
                      id="note-type-label"
                      style={{
                        color: '#1976d2',
                        fontWeight: 500,
                        fontSize: 15,
                        letterSpacing: 0.2,
                      }}
                    >
                      Type
                    </InputLabel>
                    <Select
                      labelId="note-type-label"
                      value={noteType}
                      label="Type"
                      onChange={async (e) => {
                        const val = e.target.value;
                        setNoteType(val);
                        if (val === 'Survey') {
                          setSurveyLoading(true);
                          try {
                            const qRes = await axios.get('/adminNotesSurvey/get-survey-question?surveyType=6');
                            let notes = (qRes.data?.response || []).map(q => ({
                              surveyQuestionId: q.surveyQuestionId,
                              surveyQuestion: q.question,
                              surveyType: q.surveyType,
                              answer: null, // No answer yet
                              isCustom: false,
                            }));
                            setSurveyNotes(notes);
                            setSurveySubmitted(false);
                            setSurveyRatings({});
                            setCustomQuestion('');
                            setCustomRating(0);
                          } catch {
                            setSurveyNotes([]);
                            setSurveySubmitted(false);
                          } finally {
                            setSurveyLoading(false);
                          }
                        } else {
                          setSurveySubmitted(false);
                        }
                      }}
                      sx={{
                        background: "#fff",
                        borderRadius: 2,
                        fontWeight: 500,
                        color: "#1976d2",
                        fontSize: 15,
                        transition: "border-color 0.2s",
                        "&:hover": {
                          borderColor: "#1976d2",
                        },
                        boxShadow: "none",
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            borderRadius: 2,
                            boxShadow: "0 2px 8px #1976d220",
                          },
                        },
                      }}
                    >
                      <MenuItem value="General">General</MenuItem>
                      <MenuItem value="Survey">Survey</MenuItem>
                      <MenuItem value="Economic">Economic</MenuItem>
                    </Select>
                  </FormControl>

                  {noteType === 'Survey' && (
                    <div style={{ marginTop: 10 }}>
                      {surveyLoading ? (
                        <div style={{ fontSize: 14, color: '#888' }}>Loading...</div>
                      ) : surveySubmitted ? (
                        <div style={{ fontSize: 15, color: '#1976d2', textAlign: 'center', marginBottom: 8 }}>
                          Survey answers submitted!
                        </div>
                      ) : (
                        <>
                          {surveyNotes.length === 0 && (
                            <div style={{ fontSize: 14, color: '#888', textAlign: 'center', marginBottom: 8 }}>
                              No survey questions found.
                            </div>
                          )}
                          <div
                            style={{
                              width: '100%',
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: isMobile ? 8 : 16,
                              justifyContent: isMobile ? 'center' : 'flex-start',
                            }}
                          >
                            {surveyNotes.map((q, idx) => (
                              <div
                                key={q.surveyQuestionId || `custom-${idx}`}
                                className="survey-card"
                                style={{
                                  flex: isMobile ? '1 1 100%' : '1 1 38%',
                                  minWidth: isMobile ? '90vw' : 240,
                                  maxWidth: isMobile ? '98vw' : 320,
                                  marginBottom: isMobile ? 8 : 16,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'flex-start',
                                  padding: isMobile ? 10 : 14,
                                  borderRadius: 10,
                                  background: 'linear-gradient(135deg, #f9f9f9 60%, #e3f2fd 100%)',
                                  boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
                                  minHeight: 80,
                                  border: '1px solid #e0e0e0',
                                  position: 'relative',
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  style={{
                                    marginBottom: 6,
                                    fontWeight: 600,
                                    color: '#1976d2',
                                    fontSize: isMobile ? 13 : 15,
                                    lineHeight: 1.3,
                                  }}
                                >
                                  {q.surveyQuestion || q.customQuestion || 'Question'}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
                                  {[1, 2, 3, 4, 5].map((star) => (
                                    <span
                                      key={star}
                                      style={{
                                        cursor: !q.answer ? 'pointer' : 'default',
                                        color:
                                          (q.answer
                                            ? star <= Number(q.answer)
                                            : star <= (surveyRatings[q.surveyQuestionId] || 0))
                                            ? '#FFD700'
                                            : '#e0e0e0',
                                        fontSize: isMobile ? 20 : 22,
                                        marginRight: 2,
                                        transition: 'color 0.2s, transform 0.1s',
                                        filter: 'drop-shadow(0 1px 2px #eee)',
                                        userSelect: 'none',
                                      }}
                                      onClick={() => {
                                        if (!q.answer) {
                                          setSurveyRatings((prev) => ({
                                            ...prev,
                                            [q.surveyQuestionId]: star,
                                          }));
                                        }
                                      }}
                                      title={star + ' Star'}
                                    >
                                      ★
                                    </span>
                                  ))}
                                  {q.answer && (
                                    <span style={{ marginLeft: 8, color: '#888', fontSize: isMobile ? 12 : 13 }}>
                                      ({q.answer} / 5)
                                    </span>
                                  )}
                                </div>
                              </div>
                            ))}
                            {/* Custom Question UI */}
                            <div
                              className="survey-card"
                              style={{
                                flex: isMobile ? '1 1 100%' : '1 1 38%',
                                minWidth: isMobile ? '90vw' : 240,
                                maxWidth: isMobile ? '98vw' : 320,
                                marginBottom: isMobile ? 8 : 16,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                padding: isMobile ? 10 : 14,
                                borderRadius: 10,
                                background: 'linear-gradient(135deg, #f9f9f9 60%, #e3f2fd 100%)',
                                boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
                                minHeight: 80,
                                border: '1px solid #e0e0e0',
                                position: 'relative',
                              }}
                            >
                              <Typography
                                variant="subtitle2"
                                style={{
                                  marginBottom: 6,
                                  fontWeight: 600,
                                  color: '#1976d2',
                                  fontSize: isMobile ? 13 : 15,
                                  lineHeight: 1.3,
                                }}
                              >
                                Custom Question
                              </Typography>
                              <input
                                type="text"
                                placeholder="Enter your custom question"
                                value={customQuestion || ''}
                                onChange={e => setCustomQuestion(e.target.value)}
                                style={{
                                  width: '100%',
                                  marginBottom: 6,
                                  padding: 6,
                                  borderRadius: 6,
                                  border: '1px solid #ccc',
                                  fontSize: 14,
                                }}
                              />
                              <div style={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
                                {[1, 2, 3, 4, 5].map((star) => (
                                  <span
                                    key={star}
                                    style={{
                                      cursor: 'pointer',
                                      color: star <= customRating ? '#FFD700' : '#e0e0e0',
                                      fontSize: isMobile ? 20 : 22,
                                      marginRight: 2,
                                      transition: 'color 0.2s, transform 0.1s',
                                      filter: 'drop-shadow(0 1px 2px #eee)',
                                      userSelect: 'none',
                                    }}
                                    onClick={() => setCustomRating(star)}
                                    title={star + ' Star'}
                                  >
                                    ★
                                  </span>
                                ))}
                                {customRating > 0 && (
                                  <span style={{ marginLeft: 8, color: '#888', fontSize: isMobile ? 12 : 13 }}>
                                    ({customRating} / 5)
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          {!surveySubmitted && (
                            <div style={{ textAlign: isMobile ? 'center' : 'right', marginTop: 10 }}>
                              <Button
                                variant="contained"
                                size="small"
                                style={{
                                  minWidth: 90,
                                  fontWeight: 600,
                                  fontSize: isMobile ? 13 : 13,
                                  borderRadius: 6,
                                  boxShadow: '0 1px 6px #1976d220',
                                  // background: 'linear-gradient(90deg, #1976d2 60%, #64b5f6 100%)',
                                  color: '#fff',
                                  letterSpacing: 0.5,
                                  padding: '4px 16px',
                                  opacity: surveyNotes.length > 0 && surveyNotes.every((q) => surveyRatings[q.surveyQuestionId] > 0) ? 1 : 0.6,
                                  pointerEvents: surveyNotes.length > 0 && surveyNotes.every((q) => surveyRatings[q.surveyQuestionId] > 0) ? 'auto' : 'none',
                                }}
                                disabled={surveyNotes.length === 0 || !surveyNotes.every((q) => surveyRatings[q.surveyQuestionId] > 0)}
                                onClick={async () => {
                                  const NotesSurvey = [
                                    ...surveyNotes.map((q) => ({
                                      SurveyQuestionId: q.surveyQuestionId,
                                      Answer: String(surveyRatings[q.surveyQuestionId] || 0),
                                      CustomQuestion: "",
                                      CustomAnswer: ""
                                    })),
                                    ...(customQuestion && customRating > 0
                                      ? [{
                                        SurveyQuestionId: null,
                                        Answer: "",
                                        CustomQuestion: customQuestion,
                                        CustomAnswer: String(customRating),
                                      }]
                                      : [])
                                  ];

                                  if (NotesSurvey.length === 0) return;

                                  setSurveyLoading(true);

                                  try {
                                    const InvoiceNumber = 0; // Replace with actual invoice number if available

                                    const payload = {
                                      CustomerId: selectedCustomer,
                                      userId: 0,
                                      InvoiceNumber,
                                      NotesType: 6,
                                      NotesSurvey,
                                      Description: '',
                                    };

                                    await axios.post('/adminNotesSurvey/add-survey-response', payload);

                                    // Always reload questions after submit
                                    const qRes = await axios.get('/adminNotesSurvey/get-survey-question?surveyType=6');
                                    let notes = (qRes.data?.response || []).map(q => ({
                                      surveyQuestionId: q.surveyQuestionId,
                                      surveyQuestion: q.question,
                                      surveyType: q.surveyType,
                                      answer: null,
                                      isCustom: false,
                                    }));
                                    setSurveyNotes(notes);
                                    setSurveyRatings({});
                                    setCustomQuestion('');
                                    setCustomRating(0);
                                    setSurveySubmitted(false); // Do not show "Survey answers submitted!"
                                    setSurveyReloaded(false);
                                    fetchCommentList();
                                    fetchCustomers();
                                    toast.success('Survey answers submitted!');
                                  } catch (err) {
                                    // toast.error('Failed to submit survey answers');
                                  } finally {
                                    setSurveyLoading(false);
                                  }
                                }}
                              >
                                {surveyLoading ? 'Submitting...' : 'Submit'}
                              </Button>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  )}
                  <>
                    {(noteType === 'General' || noteType === 'Economic') && (
                      <Form>
                        <Form.Group className="modalform" style={{ marginTop: '20px', display: 'flex', alignItems: 'center' }}>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            style={{
                              resize: 'none',
                              width: '50%',
                              borderRadius: '12px',
                              borderColor: isNotesContentEmpty && '#eb5e5e',
                            }}
                            onChange={(e) => setNotesContent(e.target.value)}
                            value={notesContent}
                          />
                          <Button variant="contained" style={{ height: '40px', marginLeft: '20px' }} onClick={postAddnotes}>
                            <AddCircleIcon />
                          </Button>
                        </Form.Group>
                      </Form>)}
                    <div style={{ height: '250px', overflow: 'auto', marginTop: '10px' }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Date </TableCell>
                            <TableCell>Notes Type </TableCell>
                            <TableCell>Message</TableCell>
                            <TableCell>Added By</TableCell>
                          </TableRow>
                        </TableHead>
                        {loading ? (
                          ''
                        ) : (
                          <TableBody>
                            {commentList?.length > 0 ? (
                              commentList?.map((row, index) => (
                                <TableRow key={index}>
                                  <TableCell> {formatDate(row?.createdDate)}</TableCell>
                                  <TableCell>
                                    {row?.noteType === 2 ? "General" : row?.noteType === 6 ? "Survey" : row?.noteType === 8 ? "Economic" : row?.noteType === 4 ? "Invoice" : "Unknown"}
                                  </TableCell>
                                  {(row?.noteType === 2 || row?.noteType === 4) ?
                                    <TableCell>
                                      {row?.description?.length > 30 ? (
                                        <TooltipWithCopy text={row?.description} />
                                      ) : (
                                        row?.description
                                      )}
                                    </TableCell> : row?.noteType === 6 ? <TableCell>
                                      <Button
                                        style={{ marginLeft: '10px' }}
                                        variant="contained"
                                        onClick={async () => {
                                          setSurveyAnswersLoading(true);
                                          setViewSurveyAnswers(true);
                                          try {
                                            const res = await axios.get(`/AdminNotesSurvey/user-customer-survey-notes?noteId=${row.id}`);
                                            setSurveyAnswers(res.data?.response || []);
                                          } catch {
                                            setSurveyAnswers([]);
                                          } finally {
                                            setSurveyAnswersLoading(false);
                                          }
                                        }}
                                      >
                                        View
                                      </Button>
                                    </TableCell> : row?.noteType === 8 ? <TableCell>
                                      {row?.description?.length > 30 ? (
                                        <TooltipWithCopy text={row?.description} />
                                      ) : (
                                        row?.description
                                      )}
                                    </TableCell> : "Unknown"}
                                  <TableCell> {row?.addedBy} </TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow className="text-center">
                                <TableCell colSpan={2} style={{ textAlign: 'center' }}>
                                  No record found
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        )}
                      </Table>
                    </div>
                  </>
                </>)}
            </Box>
          </Box>
        </Modal>

        <Modal
          open={showEditModal}
          onClose={() => {
            setShowEditModal(false);
            setShowCustomerDetails(null);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Edit Customer Details
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <form
                onSubmit={handleSubmit(
                  (values) => {
                    values.countryCode = countryCode;
                    editUserDetails(values);
                  },
                  (formErrors) => {
                    toast.error("Please fill all required fields correctly.");
                  }
                )}
              >
                <div className="container" style={{ overflow: 'auto', height: '450px', width: '105%' }}>
                  <FormControl sx={{ width: 250, marginTop: '12px' }}>
                    <InputLabel id="language-label">Language</InputLabel>
                    <Select
                      labelId="language-label"
                      id="language-select"
                      value={editLanguage}
                      label="Language"
                      {...register('language', { required: true })}
                      onChange={(e) => {
                        setEditLanguage(e.target.value);
                        setValue('language', e.target.value);
                      }}
                    >
                      <MenuItem value="en-us">English</MenuItem>
                      <MenuItem value="sv-se">Swedish</MenuItem>
                    </Select>
                  </FormControl>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      '& .MuiTextField-root': { width: '25ch' },
                    }}
                  >
                    <Autocomplete
                      freeSolo
                      value={watch('accountType')}
                      id="combo-box-demo"
                      options={[
                        { label: 'Private Customer' },
                        { label: 'Business Customer' },
                        { label: 'Business Construction' },
                      ]}
                      sx={{ width: 300, marginTop: '12px' }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          {...register('accountType', {
                            required: true,
                          })}
                          label="AccountType"
                        />
                      )}
                      onChange={(event, val) => {
                        setUserAccountType(val?.label);
                      }}
                    />
                    
                    <Autocomplete
                      freeSolo
                      value={watch('invoiceType') || ''}
                      id="combo-box-demo"
                      options={[{ label: 'Email (send to email address)' }, { label: 'E-invoice (send as electronic invoice)' }, { label: 'Post (60 SEK)' }]}
                      sx={{ width: 300, marginTop: '12px' }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          {...register('invoiceType', {
                            required: true,
                          })}
                          label="Invoice Type"
                        />
                      )}
                      onChange={(event, val) => setInvoiceType(val?.label)}
                    />

                    {invoiceType === 'E-invoice (send as electronic invoice)' && (
                      <>
                        <TextField
                          label={'Our electronic reference'}
                          {...register('ourElectronicReference', {
                            required: false,
                          })}
                          defaultValue="7230020"
                          InputProps={{ readOnly: true, style: { color: '#757575' } }}
                          id="margin-none"
                          margin="normal"
                        />

                        <TextField
                          label={'Your electronic reference'}
                          {...register('yourElectronicReference', {
                            required: true,
                          })}
                          id="margin-none"
                          margin="normal"
                        />

                        <TextField
                          label={"GLN / Peppol ID"}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 18);
                          }}

                          {...register('globalLocationNumber', {
                            required: true,
                            maxLength: 18,
                            minLength: 13
                          })}
                          id="margin-none"
                          margin="normal"
                        />

                        <TextField
                          label={'Extra field 1 e-invoice (optional)'}
                          {...register('extraField1', {
                            required: false,
                          })}
                          id="margin-none"
                          margin="normal"
                        />

                        <TextField
                          label={'Extra field 2 e-invoice (optional)'}
                          {...register('extraField2', {
                            required: false,
                          })}
                          id="margin-none"
                          margin="normal"
                        />
                      </>
                    )}
                    
                    {invoiceType === 'Email (send to email address)' && (

                      <>
                        <div className="col d-flex align-items-center">
                          <div className="form-check mb-3">
                            <input
                              id="isSecondaryEmailAddress"
                              type="checkbox"
                              className="form-check-input"
                              checked={secondaryChecked}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setSecondaryChecked(checked);
                                try {
                                  register && register('isSecondaryEmailAddress');
                                } catch (err) {
                                }
                                setValue('isSecondaryEmailAddress', !checked);
                              }}
                            />
                            <label htmlFor="isSecondaryEmailAddress" className="form-check-label">
                              {`Add secondary email field for customer(${showCustomerDetails?.email}  )`}
                            </label>
                          </div>
                        </div>
                        {!secondaryChecked && (
                          <div className="row flex-xs-column gap-0">
                            <div className="col">
                              <label htmlFor="secondaryEmailAddress">{('Secondary Email')}</label>
                              <input
                                id="secondaryEmailAddress"
                                defaultValue={showCustomerDetails?.secondaryEmailAddress}
                                type="email"
                                className={`form-control form-control-md mb-3 ${errors.secondaryEmail ? 'is-invalid' : ''}`}
                                placeholder={'Secondary Email'}
                                {...register('secondaryEmailAddress', {
                                  required: true,
                                  pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                })}

                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {invoiceType === 'Post (60 SEK)' && (
                      <>
                        <div className="row flex-xs-column gap-0" style={{ marginTop: '12px' }}>
                          <div className="col">
                            <div className="form-check mb-3">

                              <input
                                id="useExistingPostal"
                                type="checkbox"
                                className="form-check-input"
                                checked={useExistingPostal}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setUseExistingPostal(checked);
                                  // Keep form field in sync with inverted boolean:
                                  // when checked -> send false, when unchecked -> send true
                                  setValue('useExistingPostal', !checked);
                                  if (checked) {
                                    setValue('postAddress', '');
                                    setValue('postCity', '');
                                    setValue('postCountry', '');
                                    setValue('postZipCode', '');
                                    setValue('postCountryCode', '');
                                  }
                                }}
                              />

                              <label htmlFor="useExistingPostal" className="form-check-label">
                                {('Use existing address for postal delivery')} (
                                {(watch('address') || showCustomerDetails?.address || '') +
                                  ((watch('city') || showCustomerDetails?.city) ? ', ' + (watch('city') || showCustomerDetails?.city) : '') +
                                  ((watch('zipCode') || showCustomerDetails?.zipCode) ? ', ' + (watch('zipCode') || showCustomerDetails?.zipCode) : '') +
                                  ((watch('country') || showCustomerDetails?.country) ? ', ' + (watch('country') || showCustomerDetails?.country) : '')}
                                )
                              </label>
                            </div>
                          </div>
                        </div>

                        {!useExistingPostal && (
                          <>
                            <div className="row flex-xs-column gap-0">
                              <div className="col">
                                <label htmlFor="postalAddress">{('Postal Address')}</label>
                                <input
                                  id="postalAddress"
                                  type="text"
                                  className={`form-control form-control-md mb-3 ${errors.postAddress ? 'is-invalid' : ''}`}
                                  placeholder={('Type here....')}
                                  {...register('postAddress', {
                                    required: true,
                                  })}
                                />
                              </div>
                            </div>

                            <div className="row flex-xs-column gap-0">
                              <div className="col">
                                <label htmlFor="postCity">{('Postal City')}</label>
                                <input
                                  id="postCity"
                                  type="text"
                                  className={`form-control form-control-md mb-3 ${errors.postCity ? 'is-invalid' : ''}`}
                                  placeholder={('Type here....')}
                                  {...register('postCity', {
                                    required: true,
                                  })}
                                />
                              </div>
                            </div>

                            <div className="row flex-xs-column gap-0">
                              <div className="col">
                                <label htmlFor="postCountry">{('Postal Country')}</label>
                                <SelectReact
                                  placeholder={('Select')}
                                  styles={customStyles}
                                  defaultValue={countryOptions?.find((item) => item.label === watch('postCountry'))}
                                  options={countryOptions}
                                  {...register('postCountry', {
                                    required: true,
                                  })}
                                  onChange={(selectedOption) => {
                                    setValue('postCountry', selectedOption?.value || '');
                                    Object.keys(countries.countries).forEach((code) => {
                                      if (countries.countries[code].name === selectedOption?.value) {
                                        setValue('postCountryCode', code);
                                      }
                                      if (selectedOption?.value === 'USA') {
                                        setValue('postCountryCode', 'US');
                                      }
                                    });
                                  }}
                                />
                              </div>
                            </div>

                            <div className="row flex-xs-column gap-0">
                              <div className="col">
                                <label htmlFor="postZipCode">{('Postal Zip Code')}</label>
                                <input
                                  id="postZipCode"
                                  type="text"
                                  className={`form-control form-control-md mb-3 ${errors.postZipCode ? 'is-invalid' : ''}`}
                                  placeholder={('Type here....')}
                                  {...register('postZipCode', {
                                    required: true,
                                  })}
                                  onInput={(e) => {
                                    const maxLength = 9;
                                    e.target.value = e.target.value.replace(/[^a-zA-Z0-9\s,-]/g, '');
                                    if (e.target.value.length > maxLength) {
                                      e.target.value = e.target.value.slice(0, maxLength);
                                    }
                                  }}
                                />
                              </div>

                              <div className="col">
                                <label htmlFor="postalCountryCode">{('Postal Country Code')}</label>
                                <select
                                  id="postCountryCode"
                                  className="form-control form-control-md mb-3"
                                  value={watch('postCountryCode') || ''}
                                  {...register('postCountryCode', {
                                    required: true,
                                  })}
                                  onChange={(e) => setValue('postCountryCode', e.target.value)}
                                >
                                  <option value="">{('Select')}</option>
                                  {countryCodeOptions.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
      
                    <TextField
                      label={'Name'}
                      {...register('name', {
                        required: true,
                      })}
                      id="margin-none"
                      margin="normal"
                    />
                    <TextField
                      type="email"
                      label={'Email'}
                      {...register('email', {
                        required: true,
                      })}
                      id="margin-normal"
                      margin="normal"
                    />
                    {watch('accountType') === 'Private Customer' ? (
                      <TextField
                        label={'SSN'}
                        {...register('ssn', {
                          required: true,
                        })}
                        onKeyDown={(e) => {
                          const inputValue = e.key;
                          const allowedCharacters = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;

                          if (inputValue !== 'Backspace' && !allowedCharacters.test(inputValue)) {
                            e.preventDefault();
                          }
                        }}
                        id="margin-none"
                        margin="normal"
                      />
                    ) : (
                      <TextField
                        label={'OrgNo'}
                        {...register('orgNo', {
                          required: false,
                        })}
                        id="margin-none"
                        margin="normal"
                        // onKeyDown={(e) => {
                        //   // const inputValue = e.key;
                        //   // const allowedCharacters = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;

                        //   // if (inputValue !== 'Backspace' && !allowedCharacters.test(inputValue)) {
                        //     e.preventDefault();
                        //   // }
                        // }}
                      />
                    )}
                    <Autocomplete
                      freeSolo
                      value={selectedCountry}
                      id="combo-box-demo"
                      options={newDetails.map(cou => ({
                               label: cou.name,
                               value: cou.name
                      }))}
                      sx={{ width: 300, marginTop: '12px' }}
                      renderInput={(params) => (
                        <TextField {...params} {...register('country', { required: true })} label="Country" />
                      )}
                      onChange={(event, newValue) => {
                        const selectedCountry = newValue;
                        setCountryValue(selectedCountry?.label === 'Sweden');
                        setCountryName(selectedCountry?.label || ''); // Set the country name state
                        setValue('country', selectedCountry?.label || ''); // Set the form value with country name
                        Object.keys(countries.countries).forEach((code) => {
                          if (countries.countries[code].name === newValue?.label) {
                            setCountryCode(code);
                          }
                          if (newValue?.label === 'USA') {
                            setCountryCode('US');
                          }
                          if (newValue?.label === 'Sweden') {
                            setCountryValue(true);
                          }
                        });
                        resetField('vatNumber', { defaultValue: '' });
                      }}
                      onKeyDown={(e) => {
                        const inputValue = e.key;
                        // This regular expression allows any character except digits (0-9)
                        const disallowedCharacters = /^[0-9]$/;

                        if (inputValue !== 'Backspace' && disallowedCharacters.test(inputValue)) {
                          e.preventDefault();
                        }
                      }}
                    />

                    {userAccountType !== 'Private Customer' && (
                      <div style={{ width: 249 }} className="">
                        <label className="ml-2" htmlFor="have_vatnumber">
                          {'Do you have VAT number?'}
                        </label>
                        <select
                          style={{ height: 53 }}
                          id="have_vatnumber"
                          className="form-control pt-2 pb-2 form-control-md mb-3"
                          {...register('isVATRegistred', { required: true })}
                          defaultValue={isVatRegisterSelected ? 'true' : 'false'}
                          disabled={(selectedCountry === 'Sweden' || countryName === 'Sweden') && userAccountType === 'Business Construction'}
                          onChange={(e) => {
                            const value = e.target.value === 'true';
                            setIsVatRegisterSelected(value); // Update the state based on user selection
                            setValue('isVATRegistred', e.target.value); // Update the form value for isVATRegistred
                          }}
                        >
                          <option value="true">{'Yes'}</option>
                          <option value="false">{'No'}</option>
                        </select>
                      </div>
                    )}

                    {userAccountType !== 'Private Customer' && isVatRegisterSelected && (
                      <div style={{ display: 'flex' }}>
                        {/* Country Code Dropdown */}
                        <FormControl sx={{ marginTop: '12px', flex: 1, minWidth: 80 }}>
                          <select
                            className="form-control form-control-sm"
                            style={{ width: 80, display: "inline-block", height: '100%' }}
                            value={countryCode}
                            label="Code"
                            onChange={(e) => {
                              //  setVatCountryCode(e.target.value);
                              setCountryCode(e.target.value)
                            }}
                            size="small"
                          >
                            {countryCodeOptions.map((opt) => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </select>
                        </FormControl>

                        <TextField
                          sx={{ marginTop: '12px' }}
                          label={'Vat. Number'}
                          placeholder={vatPlaceholder(countryCode)}
                          {...register('vatNumber', {
                            required: countryVal === false && userAccountType !== 'Private Customer',
                            validate: (value) => validateVatNumber(countryCode, value),
                          })}
                          id="right-box"
                          style={{ flex: 4 }}
                          onKeyDown={(e) => {
                            const allowedCharacters =
                              vatFormats[countryCode]?.allowedCharacters || /^[ A-Za-z0-9_@./#&+-]*$/;
                            if (
                              allowedCharacters.test(e.key) ||
                              ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)
                            ) {
                              return true;
                            } else {
                              e.preventDefault();
                              return false;
                            }
                          }}
                          onInput={(e) => {
                            setIsVatVerifiedChecked(false);
                            const input = e.target;
                            const maxLength = vatFormats[countryCode]?.maxLength || 18;
                            let value = input.value;
                            if (value.length > maxLength) {
                              value = value.slice(0, maxLength);
                              input.value = value;
                            }
                          }}
                          error={!!errors.vatNumber}
                          helperText={errors.vatNumber ? errors.vatNumber.message : ''}
                        />
                      </div>
                    )}

                    {userAccountType !== 'Private Customer' && isVatRegisterSelected && (
                      <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <input
                          id="isVatVerifiedCheckbox"
                          type="checkbox"
                          checked={isVatVerifiedChecked}
                          disabled={!watch('vatNumber')}
                          onChange={(e) => setIsVatVerifiedChecked(e.target.checked)}
                          style={{ width: 16, height: 16, cursor: watch('vatNumber') ? 'pointer' : 'not-allowed' }}
                          title={!watch('vatNumber') ? 'Enter a VAT number before marking as verified' : ''}
                        />
                        <label
                          htmlFor="isVatVerifiedCheckbox"
                          style={{ marginBottom: 0, fontSize: 14, cursor: watch('vatNumber') ? 'pointer' : 'not-allowed', color: !watch('vatNumber') ? '#aaa' : 'inherit' }}
                        >
                          VAT Verified
                        </label>
                      </div>
                    )}

                    <TextField
                      label={'PhoneNo'}
                      {...register('phoneNumber', {
                        required: true,
                      })}
                      onKeyDown={(e) => {
                        const inputValue = e.key;
                        const allowedCharacters = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;

                        if (inputValue !== 'Backspace' && !allowedCharacters.test(inputValue)) {
                          e.preventDefault();
                        }
                      }}
                      id="margin-normal"
                      margin="normal"
                    />
                    <TextField
                      label={'ZipCode'}
                      onKeyDown={(e) => {
                        const inputValue = e.key;
                        const allowedCharacters = /^[a-zA-Z0-9\s,-]$/;
                        if (inputValue !== 'Backspace' && !allowedCharacters.test(inputValue)) {
                          e.preventDefault();
                        }
                      }}
                      {...register('zipCode', {
                        required: true,
                      })}
                      id="margin-none"
                      margin="normal"
                      onInput={(e) => {
                        const maxLength = 9;
                        e.target.value = e.target.value.replace(/[^a-zA-Z0-9\s,-]/g, '');
                        if (e.target.value.length > maxLength) {
                          e.target.value = e.target.value.slice(0, maxLength);
                        }
                      }}
                    />
                    <TextField
                      label={'Address'}
                      {...register('address', {
                        required: true,
                      })}
                      id="margin-dense"
                      margin="normal"
                    />
                    {userAccountType !== 'Private Customer' && (
                      <TextField label={'Address 2 (optional)'} {...register('address2')} id="margin-dense" margin="normal" />
                    )}
                    <TextField
                      label={'City'}
                      {...register('city', {
                        required: true,
                      })}
                      id="margin-normal"
                      margin="normal"
                      onKeyDown={(e) => {
                        const inputValue = e.key;
                        // This regular expression allows any character except digits (0-9)
                        const disallowedCharacters = /^[0-9]$/;

                        if (inputValue !== 'Backspace' && disallowedCharacters.test(inputValue)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    <TextField
                      label={'Reference'}
                      {...register('reference', {
                        required: true,
                      })}
                      id="margin-normal"
                      margin="normal"
                    />
                    <TextField label={'CO'} {...register('co', {
                      required: false,
                    })} id="margin-normal" margin="normal" />
                    <Autocomplete
                      freeSolo
                      value={watch('paymentTerm')}
                      id="combo-box-demo"
                      onKeyDown={(e) => {
                        const inputValue = e.key;
                        const allowedCharacters = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;

                        if (inputValue !== 'Backspace' && !allowedCharacters.test(inputValue)) {
                          e.preventDefault();
                        }
                      }}
                      options={[
                        { label: 0 },
                        { label: 10 },
                        { label: 15 },
                        { label: 20 },
                        { label: 30 },
                        { label: 45 },
                        { label: 60 },
                      ]}
                      sx={{ width: 300, marginTop: '12px' }}
                      renderInput={(params) => (
                        <TextField {...params} {...register('paymentTerm')} label="PaymentTerm" />
                      )}
                    />
                  </Box>
                </div>
                <Button
                  variant="contained"
                  onClick={() => {
                    setShowEditModal(false);
                    setShowCustomerDetails(null);
                  }}
                >
                  Close
                </Button>
                <Button style={{ marginLeft: '10px' }} variant="contained" type="submit">
                  Save Changes
                </Button>
              </form>
            </Typography>
          </Box>
        </Modal>

        <Modal
          open={showSyncModal}
          onClose={(prevState) => {
            setshowSyncModal(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <Box sx={getModalBoxStyle()}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Are you sure you want to sync?
            </Typography>

            <div style={{ margin: '25px 0 0', float: 'right', gap: '10px', display: 'flex', alignItems: 'center' }}>
              <Button
                onClick={(prevState) => {
                  setshowSyncModal(false);
                }}
                sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                autoFocus
              >
                No
              </Button>

              {!isError && (
                <Button onClick={handleSyncProceed} sx={{ float: 'right', backgroundColor: '#62b5e514' }} autoFocus>
                  Yes
                </Button>
              )}
            </div>
          </Box>
        </Modal>

        <TablePagination
          rowsPerPageOptions={[100, 250, 500]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        {/* VAT Verification Confirmation Dialog */}
        <Modal
          open={vatConfirmAction !== null}
          onClose={() => !vatVerifyLoading && setVatConfirmAction(null)}
          aria-labelledby="vat-confirm-title"
        >
          <Box sx={getModalBoxStyle()}>
            <Typography id="vat-confirm-title" variant="h6" component="h2">
              {vatConfirmAction === 'verify' ? 'Confirm VAT Verification' : 'Confirm Remove VAT Verification'}
            </Typography>
            <Typography sx={{ mt: 1.5 }}>
              {vatConfirmAction === 'verify'
                ? "Are you sure you want to manually mark this customer's VAT as verified? This will override the automatic API check."
                : "Are you sure you want to remove VAT verification for this customer?"}
            </Typography>
            <div style={{ margin: '25px 0 0', float: 'right', gap: '10px', display: 'flex', alignItems: 'center' }}>
              <Button
                onClick={() => { setVatConfirmAction(null); setVatActionCustomer(null); }}
                disabled={vatVerifyLoading}
                sx={{ backgroundColor: '#62b5e514' }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color={vatConfirmAction === 'verify' ? 'success' : 'error'}
                disabled={vatVerifyLoading}
                onClick={() => handleVatVerify(vatConfirmAction === 'verify')}
                startIcon={vatVerifyLoading ? <CircularProgress size={14} sx={{ color: 'inherit' }} /> : null}
              >
                {vatVerifyLoading ? 'Processing...' : 'Confirm'}
              </Button>
            </div>
          </Box>
        </Modal>
      </>
    );
  };

  return (
    <Page title="Customers">
      {loading && <Loader />}
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Stack direction="row" alignItems="center">
            <IconButton onClick={() => navigate(-1)}>
              <Iconify icon="eva:arrow-back-fill" width={24} height={24} />
            </IconButton>
            <Typography variant="h4" sx={{ ml: 1 }}>
              Customers
            </Typography>
          </Stack>

          <Stack direction="row" justifyContent="space-between">
            <Tooltip arrow title={'Sync To Fortnox'}>
              <Button style={{ marginLeft: '10px' }} variant="contained" onClick={() => setshowSyncModal(true)}>
                Sync To Fortnox
              </Button>
            </Tooltip>

            <Tooltip arrow title={'Download Customer Survey'}>
              <Button
                style={{ marginLeft: '10px' }}
                variant="contained"
                onClick={handleDownloadSurvey}
              >
                Download Customer Survey
              </Button>
            </Tooltip>
          </Stack>
        </Stack>

        <ErrosAlert
          isError={isError}
          messages={messages}
          setshowSyncModal={setshowSyncModal}
          setisError={setisError}
          setMessages={setMessages}
          handleButtonClick={handleButtonClick}
        />

        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={isSnackBarOpen}
          autoHideDuration={autoHideDuration}
          onClose={handleSnackBarClose}
        >
          <Alert onClose={handleSnackBarClose} severity={alertStatus} sx={{ width: '100%' }}>
            {alertMessage}
          </Alert>
        </Snackbar>

        <Card>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={selectedTabValue}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={(e, newValue) => handleTabChange(e, newValue)} aria-label="lab API tabs example">
                  <Tab label="CUSTOMERS" value="1" />
                </TabList>
              </Box>
              <TabPanel value="1" sx={{ padding: 0 }}>
                {RenderCustomers()}
              </TabPanel>
            </TabContext>
          </Box>
        </Card>

        {/* SSN Verification Modal */}
        <SSNVerificationModal
          open={ssnVerificationModal.show}
          onClose={() => setSsnVerificationModal({ show: false, expectedData: null, sparData: null, reason: '', status: '', customerId: null, ssn: null, isSsnValid: null, isPending: false })}
          verificationData={ssnVerificationModal}
          onManualVerification={handleManualSSNVerification}
          loading={loading}
          onVerificationComplete={() => {
            fetchCustomers();
          }}
        />
      </Container>
    </Page>
  );
}
